import React from 'react';

import ElapsedTimeEventTracker from 'analytics/ElapsedTimeEventTracker';
import {ELN_ANALYTICS_ACTIONS} from 'constants/AnalyticsConstants';
import ErrorTriangle, {TriangleLocation, TriangleState} from 'notebook/tables/errors/ErrorTriangle';

import {EvaluatedCellError} from '../excess/Evaluator';

interface Props {
  error: EvaluatedCellError;
  location: TriangleLocation;
}

export default class IllegalErrorTriangle extends React.PureComponent<Props> {
  eventTracker: ElapsedTimeEventTracker;

  constructor(props: Props) {
    super(props);
    this.eventTracker = new ElapsedTimeEventTracker(ELN_ANALYTICS_ACTIONS.HOVERED_ILLEGAL_ERROR_TRIANGLE);
  }

  render(): JSX.Element {
    const {location, error} = this.props;
    return (
      <ErrorTriangle
        location={location}
        error={error}
        onMouseEnter={() => {
          this.eventTracker.startTimer();
        }}
        onMouseLeave={() => {
          this.eventTracker.stopTimerAndTrack();
        }}
        state={TriangleState.ILLEGAL}
        dataTestAttrs={{component: 'IllegalErrorTriangle', element: 'errorCell'}}
      />
    );
  }
}
